export default __webpack_public_path__ + "static/media/conun.2ac3b07b.jpg";